import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'babel-polyfill'
import axios from 'axios';
import repository from './repository'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import german from './config/validation_localization';
import * as rules from 'vee-validate/dist/rules';

import './assets/styles/index.css';

localize('de', {
  messages: german.messages
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

extend('date', value => {
  if (!value)
    return false;

  const regex = /^\d{1,2}\.\d{1,2}\.\d{4}$/;
  if (!regex.test(value)) {
      return false;
  }

  // Splitten des Strings in Tag, Monat und Jahr
  const [day, month, year] = value.split('.').map(Number);

  // Prüfen, ob das Datum gültig ist
  const date = new Date(year, month - 1, day);

  // Check: Ist das Datum korrekt geparst?
  return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
  );
});

extend('decimal', {validate(value, {precision}) {
  if (value[0] && value[0] ==='€') {
    value = value.slice(1);
  }
  value = value.split(" ").join("");

  var parts = value.split(".").join("").split(',');

  if (parts.length > 2) 
    return false; 
  
  
  if ((parts.length > 1) && (parts[1].length > precision))
    return false;
  

  var isAllNumber = true;
  parts.forEach(part => {
    if (!rules.numeric.validate(part) || part < 0)
      isAllNumber = false;
  });

  return isAllNumber;
  },
  params:['precision']
});



Vue.config.productionTip = false
Vue.config.errorHandler = (err, vm, info) => {
  if (location.hostname === "localhost"){
    console.error(err);
    return;
  }

  repository.service.error.post({
    message: "Stack: " + err.stack,
    channel: "mkm_forms_log_n",
    subject: "Fehler in " + vm.$route.fullPath,
    emoji: ":red_circle:",
  });
};

Vue.prototype.$http = axios;

const IE11RouterFix = {
  methods: {
    hashChangeHandler: function () { this.$router.push(window.location.hash.substring(1, window.location.hash.length)); },
    isIE11: function () { return !!window.MSInputMethodContext && !!document.documentMode; }
  },
  mounted: function () { if (this.isIE11()) { window.addEventListener('hashchange', this.hashChangeHandler); } },
  destroyed: function () { if (this.isIE11()) { window.removeEventListener('hashchange', this.hashChangeHandler); } }
};

new Vue({
  mixins: [IE11RouterFix],
  provide: repository,
  router: router,
  render: h => h(App)
}).$mount('#app')